export interface Livery {
  id: string;
  name: string;
  body: string;
  accent: string;
  helmet: string;
}

/**
 * Invented teams. Real motorsport constructor names and liveries are
 * trademarked, and none of this needs them.
 */
export const LIVERIES: Livery[] = [
  { id: 'vantari', name: 'Vantari', body: '#d92b2b', accent: '#f5d76e', helmet: '#f4f4f6' },
  { id: 'kestrel', name: 'Kestrel', body: '#2f6fd0', accent: '#8fd0ff', helmet: '#12325c' },
  { id: 'nordvik', name: 'Nordvik', body: '#eceef2', accent: '#1c3d6b', helmet: '#d02f3f' },
  { id: 'aurelio', name: 'Aurelio', body: '#f2c12e', accent: '#2b2b2f', helmet: '#2b2b2f' },
  { id: 'torrent', name: 'Torrent', body: '#17a5a0', accent: '#f0f4f4', helmet: '#0c4f4d' },
  { id: 'basalt', name: 'Basalt', body: '#2a2c31', accent: '#f07f2b', helmet: '#f07f2b' },
  { id: 'meridian', name: 'Meridian', body: '#3aa64a', accent: '#efeed8', helmet: '#1d5127' },
  { id: 'cinder', name: 'Cinder', body: '#b5359c', accent: '#ffd6f5', helmet: '#4a0f3f' },
];

export function liveryById(id: string): Livery {
  return LIVERIES.find((l) => l.id === id) ?? LIVERIES[0];
}
